import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';

import { gameResourcesService } from '../../../services/gameResourcesService';

const WildFireScene = observer(({ containerConfig }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const spine = new Spine({ key: 'mainBg' });
    spine.x = isMobile() ? 270 : 720;
    spine.y = isMobile() ? 480 : 405;
    containerRef.current.addChild(spine);
    gameResourcesService.setWildFireScene(spine);
  }, [containerRef]);

  return <Container ref={containerRef} {...containerConfig} name='WildFireScene' />;
});

export default WildFireScene;
